// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './LoginLayout.styles';
// import { Paper } from '@material-ui/core';
import { LoginHeader, LoginFooter, LoginMain } from '..';

export class LoginLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <LoginHeader />
        <LoginMain />
        <LoginFooter />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LoginLayout);
